<div class="paperless-banner-container">
  <div class="paperless-banner-image-content" [style.height.px]="contentHeight">
    <img src="/assets/img/images/paperless-banner2.png" alt="image">
  </div>

  <div class="paperless-banner-info-container" #contentRef>
    <div class="paperless-banner-info-title">
      {{ "GO_PAPERLESS" | translate }}
    </div>

    <div class="paperless-banner-info-content">
      {{ "GO_PAPERLESS_SUBTEXT" | translate }}
    </div>

    <div class="large-btn-start-container">
    <button
         class="btn mapfre basic primary large-btn"
        (click)="enrollInPaperless('PaperLess Carousel sign up for paper')"
        id="paperless-enroll-in-papers"
      >
        Enroll in paperless
      </button>

      <button
        class="btn mapfre ghost secondary large-btn"
        (click)="notNow('PaperLess Carousel not now')"
        id="paperless_notnow"
      >
        Not now
      </button>
    </div>
  </div>
</div>
